<template>
  <div class="container visitPlanAdd">
    <div>
      <p class="icon-jujue closeBtn" @click="goBack"></p>
    </div>
    <div class="searchBox">
      <div class="searchBox_top">
        <template>
          <el-button v-if="isSave" type="primary" v-acl="MsvDraft" @click="saveVisitPlan('visitPlanFrom')">{{$t('visitPlan.draftSave')}}</el-button>
          <el-button v-if="isSubmit" type="primary" v-acl="MsvSubmit" @click="submitVisitPlan('visitPlanFrom')">{{$t('common.submit')}}</el-button>
        </template>
        <template v-if="isActive" v-acl="MsvDraft">
          <br />
          <label style="font-size:12px;color:#F56C6C;">{{$t('visitPlan.operationTips')}}</label>
        </template>
      </div>
      <el-form :model="visitPlanFrom" ref="visitPlanFrom" :rules="queryConditionRules" inline label-width="120px">
        <el-row>
          <!--计划单据编号-->
          <el-col :span="8">
            <el-form-item :label="$t('visitPlan.Number')" prop="msvNo">
              <el-input v-model="visitPlanFrom.msvNo" disabled placeholder="保存后生成"></el-input>
            </el-form-item>
          </el-col>
          <!--拜访年份-->
          <el-col :span="8">
            <el-form-item :label="$t('visitPlan.Year')" prop="year">
              <el-date-picker v-model="visitPlanFrom.year" type="year" :disabled="yearStatus" clearable value-format="yyyy" placeholder="选择年"></el-date-picker>
            </el-form-item>
          </el-col>
          <!--备注-->
          <el-col :span="8">
            <el-form-item :label="$t('visitPlan.Remark')" prop="remarks">
              <el-input v-model="visitPlanFrom.remarks" clearable :disabled="isDisabled" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="计划明细" name="first">
        <div class="toolsBox">
          <el-button size="small" type="primary" v-acl="MsvAddPlanDetail" v-if="isNew" @click="addPlanDetail">{{$t('common.addNew')}}</el-button>
          <el-button size="small" type="primary" v-acl="MsvInactive" @click="inactive">Inactive</el-button>
        </div>
        <el-table :data="tableList" ref="tableList" border fit max-height='380'>
          <el-table-column type="selection" fixed min-width="55"></el-table-column>
          <el-table-column type="index" min-width="55" label='序号'></el-table-column>
          <el-table-column show-overflow-tooltip prop="type" :label="$t('visitPlan.Type')" min-width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="category" :label="$t('visitPlan.Category')" min-width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('visitPlan.SupplierFacility')" min-width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="responsibleCqs" :label="$t('visitPlan.ResponsibleCQS')" min-width="150">
            <template slot-scope="scope">
              <PickupUser title="选择人员" :inputStatus="inputStatus" v-model="scope.row.responsibleCqs" @value="scope.row.responsibleCqs?'scope.row.responsibleCqs':' '" placeholder="请输入负责人"></PickupUser>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="riskLevel" :label="$t('visitPlan.OverallRiskLevel')" min-width="150">
            <template slot-scope="scope">
              <el-select @change="riskLevelChange(scope.row)" v-model="scope.row.riskLevel" class="handle-input" :disabled="inputStatus">
                <el-option :key="index" v-for="(item,index) in riskLevelList" :label="item.code" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="frequency" :label="$t('visitPlan.Frequency')" min-width="160">
            <!--拜访频率-->
            <template slot-scope="scope">
              <el-input v-model="scope.row.frequency" disabled></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="monthOne" label="Month1" min-width="150">
            <template slot-scope="scope">
              <el-date-picker style="width:100%" v-model="scope.row.monthOne" type="month" placeholder="请选择" format="yyyy-MM" value-format="yyyy-MM" :disabled="setMonth1Disabled(scope.row)"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="monthOneStatusI18n" label="Month1状态" min-width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="monthTwo" label="Month2" min-width="150">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.monthTwo" type="month" placeholder="请选择" value-format="yyyy-MM" :disabled="setMonth2Disabled(scope.row)" style="width:100%"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="monthTwoStatusI18n" label="Month2状态" min-width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" :label="$t('visitPlan.Remark')" min-width="100">
            <template slot-scope="scope">
              <el-input :disabled="setMonth1Disabled(scope.row)&&setMonth2Disabled(scope.row)" v-model="scope.row.remark"></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="creater" :label="$t('visitPlan.CreateUser')" min-width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('visitPlan.CreateDate')" min-width="100">
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="updater" :label="$t('visitPlan.UpdateUser')" min-width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="updateDate" :label="$t('visitPlan.UpdateDate')" min-width="100">
            <template slot-scope="scope">{{scope.row.updateDate | dateFormatFilter("YYYY-MM-DD")}}</template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('visitPlan.ModifyLog')" name="second">
        <el-table :data="logList" ref="logList" border fit>
          <el-table-column show-overflow-tooltip prop="describe" :label="$t('common.description')" width='200'></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.operation')" width='100'></el-table-column>
          <el-table-column show-overflow-tooltip prop="detail" :label="$t('common.ModifyContent')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime')" width='100'>
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="creater" :label="$t('common.OperatorName')" width='100'></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog el-dialog :title="$t('visitPlan.AddPlanDetails')" :visible.sync="addPlanDetailsVisible" width="80%">
      <div class="searchBox">
        <el-form :model="queryCondition" ref="queryCondition" inline label-width="160px">
          <el-form-item label="Type" prop='type'>
            <!--供应商类型-->
            <el-select v-if="!isHGS" v-model="queryCondition.type" @change="typeChange">
              <el-option :key="index" v-for="(item,index) in typeList" :label="item.chineseValue" :value="item.code"></el-option>
            </el-select>
            <el-input v-if="isHGS" v-model="queryCondition.type" readonly></el-input>
          </el-form-item>
          <el-form-item label="Facility" prop='supplier'>
            <el-input v-model="queryCondition.supplier" clearable></el-input>
          </el-form-item>
          <template v-if="Categorylevel">
            <el-form-item label="Category level1 Name" prop='categoryLevel1Name'>
              <el-input v-model="queryCondition.categoryLevel1Name" clearable readonly></el-input>
            </el-form-item>
            <el-form-item label="Category level2 Name" prop='categoryLevel2Name'>
              <el-autocomplete @select="name2Change" class="inline-input" v-model="queryCondition.categoryLevel2Name" :fetch-suggestions="querySearch" clearable ref='elautocomplete' placeholder="请输入内容"></el-autocomplete>
            </el-form-item>
          </template>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button type="primary" @click="restQueryFormThis2">{{$t('common.reset')}}</el-button>
            <el-button type="primary" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <div class="toolsBox">
        <el-button type="primary" @click="save">{{$t('common.confirm')}}</el-button>
      </div>
      <el-table :data="tableList2" ref="tableList2" border fit :row-key="(row)=>{return row.tmSupplierId+row.type+row.categoryLevel2Code+row.categoryLevel3Code}" @selection-change="selectionChange" height='300'>
        <el-table-column type="selection" min-width="55" :reserve-selection="true"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('visitPlan.FactoryNo')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('visitPlan.FactoryName')"></el-table-column>
        <template v-if="Categorylevel">
          <el-table-column show-overflow-tooltip prop="parentSupplierCode" :label="$t('visitPlan.SupplierNo')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="parentSupplierName" :label="$t('visitPlan.SupplierName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="dcCategory.categoryLevel1Name" label="Category level1 Name" min-width='130'></el-table-column>
          <el-table-column show-overflow-tooltip prop="dcCategory.categoryLevel2Name" label="Category level2 Name" min-width="130"></el-table-column>
        </template>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="原因" :visible.sync="ReasonVisible" width="40%">
      <el-form :model="ReasonForm" ref="ReasonForm" :rules="ReasonFormRules" inline>
        <el-form-item label="请填写原因 " label-width="120" prop="comments" class="comments">
          <el-input v-model="ReasonForm.comments" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ReasonVisible = false" type="primary">取 消</el-button>
        <el-button type="primary" @click="defineInactive('ReasonForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  visitPlanAdddraft,
  visitPlanAdddSubmit,
  visitPlanAddInactive,
  getVisitPlanDetail,
  getVisitPlanLogList,
  getCategoryValue,
  visitPlanDetailAddSeach
} from "@/api/visitPlan.js";
import PickupUser from "@/components/page/visitPlan/pickupUser";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils";
import commonFun from "@/utils/commonFun";
import { Message } from "element-ui";
import store from "@/store";

export default {
  name: "",
  components: { PickupUser },
  data() {
    return {
      ReasonVisible: false,
      ReasonForm: {
        comments: ""
      },
      ReasonFormRules: {
        comments: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ]
      },
      year: '',
      activeName: "first",
      dataArr: [],
      totalCount: 0,
      tableList: [],
      riskLevelList: [],
      visitPlanFrom: {
        pageSize: 15,
        pageNum: 1,
        year: ""
      },
      addPlanDetailsVisible: false,
      isSubmit: true,
      isSave: true,
      isActive: true,
      isNew: true,
      isDisabled: false,
      yearStatus: false,
      inputStatus: false,
      ttMsvId: '',
      addPlanDetailsForm: {
        type: "Food"
      },
      categoryLevel2NameList: [],
      categoryLevel3NameList: [],
      status: null,
      rows: [],
      Categorylevel: true,
      typeList: [],
      logList: [],
      addPlanDetailsTable: [],
      queryConditionRules: {
        year: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ]
      },
      //弹框中的字段
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        categoryLevel1Name: "Food",
        type: "Food",
        categoryLevel2Name: '',
        categoryLevel3Name: '',
        supplier: ''
      },
      tableList2: [],
      SuperAdmin: false,
      creater: '',
      isHGS: false,
      selectRows: [],
      username: '',
      userId: '',
      ms_roles: null,
      createBy: "",
      isMonth1: false,
      isMonth2: false,
    };
  },
  computed: {
    selection() {
      return this.$refs.table.selection;
    }
  },
  created() {
    this.username = localStorage.getItem("ms_username");
    this.ms_roles = localStorage.getItem("ms_roles");
    this.userId = localStorage.getItem("ms_userId");
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    for (let i = 0, len = permission.length; i < len; i++) {
      if (permission[i] == 'MSV_ADMIN') {//超级管理员
        this.SuperAdmin = true;
      }
    }
    let functions = store.state.main.functions;
    if (functions.indexOf('IS_HGS') >= 0) {
      this.queryCondition.type = 'Package';
      this.queryCondition.categoryLevel1Name = 'Package';
      this.Categorylevel = false;
      this.isHGS = true;
      this.getName2("Package")
    } else {
      this.getName2("Food")
    }
    if (this.$route.query.ttMsvId) {
      this.ttMsvId = this.$route.query.ttMsvId;
      this.getDetail(this.$route.query.ttMsvId)
      this.getLogList(this.$route.query.ttMsvId)
    }
    this.queryData(1);
    this.getInputChoiceValues();
  },
  mounted() {

  },
  methods: {
    setMonth1Disabled(row) {
      if (this.status == "SUBMIT") {
        if (!row.msvOneReportNo) {
          if (this.createBy == this.userId || (row.responsibleCqs == this.username && this.ms_roles.indexOf('MSV_SYSTEM') !== -1)) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      } else {
        return false
      }
    },
    setRemarkDisabled(row) {
      if (this.status == "SUBMIT") {
        if (!row.msvOneReportNo) {
          if (this.createBy == this.userId || (row.responsibleCqs == this.username && this.ms_roles.indexOf('MSV_SYSTEM') !== -1)) {
            return false
          } else {
            return true
          }
        } else {

        }
      } else {
        return false
      }
    },
    setMonth2Disabled(row) {
      if (row.riskLevel == 'H') {
        if (this.status == "SUBMIT") {
          if (!row.msvTwoReportNo) {
            if (this.createBy == this.userId || (row.responsibleCqs == this.username && this.ms_roles.indexOf('MSV_SYSTEM') !== -1)) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        } else {
          return false
        }
      } else {
        return true
      }
    },
    getDetail(id) {
      let that = this;
      getVisitPlanDetail(id).then(res => {
        that.creater = res.data.creater
        that.status = res.data.status
        that.createBy = res.data.createBy
        let tableList = res.data.msvDetails
        if (that.status == "DRAFT") {//保存过
          that.yearStatus = true//保存 年份不可改
        } else if (that.status == "SUBMIT") {
          that.isDisabled = true
          that.isSave = false
          that.isActive = false
          that.yearStatus = true//提交 年份不可改
          that.inputStatus = true//提交 年份不可改
          that.isNew = false//提交后不可新增
          if (res.data.createBy == that.userId || this.ms_roles.indexOf('MSV_SYSTEM') !== -1) {
            that.isSubmit = true
          } else {
            that.isSubmit = false
          }
          //如果是当前操作人则不可修改
          console.log('res.data.createBy', res.data.createBy);
          console.log('that.userId', that.userId);
          console.log('res.data.createBy === that.userId', res.data.createBy == that.userId);
          // || (ms_roles.indexOf('MSV_SYSTEM') !== -1 && isBol)
          // && !that.$route.query.month1
        }
        //循环数组添加删除用的标示
        for (let i = 0, len = tableList.length; i < len; i++) {
          tableList[i].delIds = i;
        }
        that.tableList = tableList
        that.visitPlanFrom.msvNo = res.data.msvNo
        that.year = res.data.year
        if (res.data.year) {
          that.$set(that.visitPlanFrom, "year", res.data.year.toString());
        } else {
          that.$set(that.visitPlanFrom, "year", '');
        }
        that.$set(that.visitPlanFrom, "remarks", res.data.remarks);
      });
    },
    toggleSelection() {
      this.$refs.tableList2.clearSelection();
    },
    saveVisitPlan() {
      let that = this;
      if (this.visitPlanFrom.year == '') {
        that.$message({
          message: '请选择年份',
          type: "error"
        });
        return false;
      }
      let list = this.tableList;
      // for (let i = 0,len=list.length;i<len;i++){
      //   list[i].creater ='';
      //   list[i].updateBy ='';
      // }
      let data = {
        msvDetails: list,
        msvNo: this.visitPlanFrom.msvNo,
        year: !!this.visitPlanFrom.year ? this.visitPlanFrom.year : '',
        remarks: !!this.visitPlanFrom.remarks ? this.visitPlanFrom.remarks : '',
        ttMsvId: !!this.ttMsvId ? this.ttMsvId : '',
      };
      visitPlanAdddraft(data).then(res => {
        console.log(res)
        if (res.meta.success) {
          that.$set(that.visitPlanFrom, "msvNo", res.data);
          that.ttMsvId = res.data.ttMsvId
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
          this.getDetail(res.data.ttMsvId)
          //重新获取修改日志
          this.getLogList(res.data.ttMsvId)
        }
      });
    },
    submitVisitPlan(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let list = this.tableList
          if (list.length < 1) {
            that.$message({
              message: '请维护行明细',
              type: "warning"
            });
            return false;
          }
          for (let i = 0, len = list.length; i < len; i++) {
            //先判断 如果monthOne已经取消（CANCEL）就不用验证
            if (list[i].monthOneStatus != "CANCEL" && (list[i].responsibleCqs == null || list[i].responsibleCqs == "")) {
              that.$message({ message: "CQS负责人为必填", type: "warning" });
              return;
            }
            if (list[i].monthOneStatus != "CANCEL" && (list[i].riskLevel == null || list[i].riskLevel == "")) {
              that.$message({ message: "风险水平为必填", type: "warning" });
              return;
            }
            if (list[i].monthOneStatus != "CANCEL" && (list[i].monthOne == null || list[i].monthOne == "")) {
              that.$message({ message: "Month1为必填", type: "warning" });
              return;
            }
            if (list.length > 1) {
              if (list[i + 1]) {
                if (list[i].monthOneStatus != "CANCEL" && list[i + 1].monthOneStatus != "CANCEL" && (list[i].category == list[i + 1].category)) {
                  if (list[i].supplierCode == list[i + 1].supplierCode) {
                    that.$message({ message: "同一个(category+Facility )只能存在一条计划", type: "warning", duration: 30000 });
                    return;
                  }

                }
              }
            }
            list[i].creater = '';
            list[i].updateBy = '';
          }
          let data = {
            msvDetails: list,
            msvNo: this.visitPlanFrom.msvNo,
            year: this.visitPlanFrom.year,
            remarks: !!this.visitPlanFrom.remarks ? this.visitPlanFrom.remarks : '',
            ttMsvId: this.ttMsvId ? this.ttMsvId : '',
          };
          console.log(data)
          visitPlanAdddSubmit(data).then(res => {
            console.log(res)
            if (res.meta.success) {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              that.goBack();
            }
          });
        } else {
          return false;
        }
      });
    },
    inactive() {
      let that = this;
      let list = that.tableList
      let rows = this.$refs.tableList.selection;
      // let data = []
      if (rows.length == 0) {
        that.$message({ message: "请选择需要Inactive的数据", type: "warning" });
      } else {
        if (commonFun.isNotEmpty(this.ttMsvId)) {
          if (!that.SuperAdmin) {//不是超级管理员
            if (that.creater != that.username && !commonFun.isEmpty(that.creater)) {
              that.$message({ message: "只能对自己创建的数据进行操作", type: "warning" });
              return false;
            }
          }
          let needRemark = false;
          for (let i = 0, len = rows.length; i < len; i++) {
            if (commonFun.isNotEmpty(rows[i].ttMsvDetailId)) {
              if (rows[i].monthOneStatus == "CANCEL") {
                that.$message({ message: "存在已Inactive的报告，不能重复Inactive，请重新选择", type: "warning" });
                return false;
              }
              needRemark = true;
            } else {
              for (let a = 0; a < list.length; a++) {
                if (rows[i].delIds == list[a].delIds) {
                  list.splice(a, 1);
                  a--;
                }
              }
            }

          }
          if (needRemark) {
            this.prompt("请填写原因", null, null, null, {
              inputValidator: (val) => {
                if (commonFun.isEmpty(val)) {
                  return that.$t("common.canNotBeEmpty")
                }
                return val.length < 301
              },
              inputErrorMessage: that.$t("sensory.report.reasonTooLong")
            }).then(res => {
              let rows = that.$refs.tableList.selection;
              var data = rows.map(function (item) {
                let obj = {
                  remark: res.value,
                  ttMsvDetailId: item["ttMsvDetailId"],
                  ttMsvId: that.ttMsvId,
                }
                return obj;
              });
              visitPlanAddInactive(data).then(res => {
                that.ReasonVisible = false
                that.ReasonForm.comments = ''
                if (res.meta.success) {
                  that.$message({
                    type: "success",
                    message: that.$t('common.success')
                  });
                  that.queryData()
                  that.getDetail(that.ttMsvId)
                  that.getLogList(that.ttMsvId)
                }
              });
            });
          }
        } else {
          for (let j = 0; j < rows.length; j++) {
            for (let i = 0; i < list.length; i++) {
              if (rows[j].delIds == list[i].delIds) {
                list.splice(i, 1)
                i--;
              }
            }
          }
        }
      }

      that.tableList = list;
    },
    defineInactive(formName) {
      let that = this;
      let rows = that.$refs.tableList.selection;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.refuseVisible = false;
          var data = rows.map(function (item) {
            let obj = {
              remark: that.ReasonForm.comments,
              ttMsvDetailId: item["ttMsvDetailId"],
              ttMsvId: that.ttMsvId,
            }
            return obj;
          });
          // that.ReasonVisible = false
          // console.log(data)
          visitPlanAddInactive(data).then(res => {
            that.ReasonVisible = false
            that.ReasonForm.comments = ''
            if (res.meta.success) {
              that.$message({
                type: "success",
                message: that.$t('common.success')
              });
              that.queryData()
              that.getDetail(that.ttMsvId)
              that.getLogList(that.ttMsvId)
            }
          });

        } else {
          return false;
        }
      });
    },
    getLogList(id) {
      let data = {
        "bizParentId": id,
        "bizParentType": "MSV",
        "bizType": "MSVDETAIL"
      }
      getVisitPlanLogList(data).then(res => {
        // let tableList = this.tableList
        let logList = res.data
        // for (let i = 0,len = tableList.length;i<len;i++){
        //   for (let j = 0,len2 = logList.length; j<len2;j++){
        //     if(tableList[i].ttMsvDetailId == logList[j].bizId){
        //       logList[j].serialNumber = i+1
        //     }
        //   }
        // }
        this.logList = logList
      });
    },
    addPlanDetail() {
      this.addPlanDetailsVisible = true;
      this.$refs.tableList2.clearSelection();
      this.typeChange(this.queryCondition.type);
    },
    //选择风险等级
    riskLevelChange(row) {
      let riskLevelList = this.riskLevelList
      for (var i = 0; i < riskLevelList.length; i++) {
        if (riskLevelList[i].code == row.riskLevel) {
          row.frequency = riskLevelList[i].chineseValue
        }
      }
    },
    typeChange(val) {
      this.queryCondition.categoryLevel1Name = val
      this.queryCondition.categoryLevel2Name = ''
      this.queryCondition.categoryLevel3Name = ''
      this.queryCondition.pageNum = 1;
      this.queryCondition.supplier = ''
      if (val == "Food") {
        // this.queryCondition.categoryLevel1Name = val
        this.Categorylevel = true;
        //获取name2和name3
        this.getName2(val)
      } else {
        // this.queryCondition.categoryLevel1Name = ''
        this.Categorylevel = false;
      }
      this.queryData()
    },

    getName2(value) {
      let that = this;
      let data = {
        categoryLevel1Name: value
      }
      getCategoryValue(data).then(res => {
        that.categoryLevel2NameList = res.data
      });
    },
    name2Change(val) {
      let that = this;
      this.queryCondition.categoryLevel3Name = ''
      let data = {
        categoryLevel1Name: that.addPlanDetailsForm.type,
        categoryLevel2Name: val.value,
      }
      getCategoryValue(data).then(res => {
        this.categoryLevel3NameList = res.data
      });
    },
    restQueryFormThis2: function () {
      let that = this
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      // this.queryCondition.categoryLevel1Name=''
      this.queryCondition.categoryLevel2Name = ''
      this.queryCondition.categoryLevel3Name = ''
      // this.queryCondition.type='';
      if (that.isHGS) {
        this.queryCondition.type = 'Package';
        this.queryCondition.categoryLevel1Name = 'Package';
      } else {
        this.queryCondition.type = 'Food';
        this.queryCondition.categoryLevel1Name = 'Food';
        this.Categorylevel = true;
      }

      this.queryData(1);
    },

    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_MSV:RISK_LEVEL"] = "TT_MSV:RISK_LEVEL";
      mapObj["TT_MSV:TYPE"] = "TT_MSV:TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.typeList = res["TT_MSV:TYPE"];
        this.riskLevelList = res["TT_MSV:RISK_LEVEL"];
      });
    },
    openSoucingInfo: function (sourcingNo) {
      this.$router.push({
        path: "/sourcing-detail",
        query: { sourcingNo: sourcingNo }
      });
    },
    //初始化弹框（计划明细新增）数据
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      visitPlanDetailAddSeach(this.queryCondition).then(res => {
        this.tableList2 = res.resultData;
        this.totalCount = res.totalCount
      });
    },
    querySearch(queryString, cb) {
      let that = this
      var restaurants = this.categoryLevel2NameList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.NAME
        }
      })
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      this.$refs.elautocomplete.activated = true//处理使用clearable 点击清除触发事件与重新输入值提示不显示问题
      cb(results)

    },
    querySearch2(queryString, cb) {
      var restaurants = this.categoryLevel3NameList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.NAME
        }
      })
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      this.$refs.elautocomplete2.activated = true
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    selectionChange(rows) {
      let that = this
      this.selectRows = [];
      if (rows) {
        rows.forEach(val => {
          that.selectRows.push(val);
        });
      }
    },
    //弹框中的确定
    save() {
      let arry = this.tableList;
      let that = this;
      let arryNew = [];

      // for(var c=0; c<arry.length; c++){
      //   if (arry[c].monthTwoStatus == 'CANCEL'){  //先把inctive的去掉
      //     arry.splice(c, 1)
      //   }
      // }
      let rows = this.selectRows;
      if (rows.length == 0) {
        this.addPlanDetailsVisible = false;
        // that.$message({ message: "请选择数据", type: "warning" });
      } else {
        var creater = localStorage.getItem("ms_username");
        var createDate = new Date();
        let newRow = [];
        rows.map((item, index) => {
          newRow.push(
            Object.assign({}, item, {
              creater: creater,
              createDate: createDate,
              category: rows[index].dcCategory.categoryLevel2Name,
              type: rows[index].dcCategory.categoryLevel1Name,
              updateDate: null,
              updateBy: null
            })
          );
        });
        newRow = newRow.filter(item => {//删除tmSupplierId相同的
          let arrlist = arry.map(v => v.tmSupplierId + v.type + v.categoryLevel2Code + v.categoryLevel3Code)
          return !arrlist.includes(item.tmSupplierId + item.type + item.categoryLevel2Code + item.categoryLevel3Code)
        })
        console.log(newRow)
        if (newRow.length > 0) {
          for (let b = 0, blen = newRow.length; b < blen; b++) {
            arry.push(newRow[b])
          }
        }

        for (let j = 0, len2 = arry.length; j < len2; j++) {//循环增加删除标志
          arry[j].delIds = j
        }
        this.tableList = arry

        // console.log(this.tableList)
        this.addPlanDetailsVisible = false;
      }
    },
    goBack() {
      this.$router.push({ name: 'visitPlan' });
    }
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.el-table {
  margin-top: 10px;
}

.searchBox_top {
  margin-bottom: 20px;
}
</style>
<style lang="scss">
// .visitPlanAdd {
//   .el-form-item__content {
//     width: 220px;
//   }
//   .el-select {
//     width: 100%;
//   }
//   .el-date-editor {
//     width: 220px !important;
//   }
//   .comments {
//     width: 100%;
//     .el-form-item__content {
//       width: 80%;
//     }
//   }
// }
</style>
